<template>
    <v-card v-bind="$attrs" class="account-user-info-card" outlined>
        <div class="account-user-info-card__identity">
            <span class="account-user-info-card__avatar" aria-hidden="true">{{ initials }}</span>
            <div class="account-user-info-card__copy">
                <span class="account-user-info-card__eyebrow">PROFILE CONTACT</span>
                <h3>{{ headlineDisplay }}</h3>
                <p v-if="userStoredContact.company">{{ userStoredContact.company }}</p>
            </div>
            <v-btn
                v-if="edit"
                class="account-user-info-card__edit"
                icon
                aria-label="Edit profile information"
                @click="emitEdit"
            >
                <v-icon>{{ mdiPencil }}</v-icon>
            </v-btn>
        </div>

        <div v-if="userStoredContact.email || userStoredContact.phone" class="account-user-info-card__contacts">
            <div v-if="userStoredContact.email" class="account-user-info-card__contact">
                <span class="account-user-info-card__contact-icon"><v-icon>{{ mdiEmail }}</v-icon></span>
                <span><small>Email</small>{{ userStoredContact.email }}</span>
            </div>
            <div v-if="userStoredContact.phone" class="account-user-info-card__contact">
                <span class="account-user-info-card__contact-icon"><v-icon>{{ mdiPhone }}</v-icon></span>
                <span><small>Phone</small>{{ userStoredContact.phone }}</span>
            </div>
        </div>
    </v-card>
</template>

<script>
import Vue from 'vue'
import { mdiEmail, mdiPhone, mdiPencil } from '@mdi/js'
export default Vue.extend({
    name: `AcountUserInfoMinimized`,
    inheritAttrs: false,
    props: {
        userStoredContact: {
            type: Object,
            required: true
        },
        sub: {
            type: String,
            required: true
        },
        edit: {
            type: Boolean
        }
    },
    data() {
        return {
            mdiEmail,
            mdiPencil,
            mdiPhone
        }
    },
    computed: {
        initials() {
            const first = this.userStoredContact.firstName || ''
            const last = this.userStoredContact.lastName || ''
            return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase() || 'U'
        },
        headlineDisplay() {
            if (this.userStoredContact) {
                if (this.userStoredContact.firstName && this.userStoredContact.lastName)
                    return this.userStoredContact.firstName + ` ` + this.userStoredContact.lastName
                if (this.userStoredContact.email) return this.userStoredContact.email
                else return `User Profile`
            } else return `No user profile found`
        }
    },
    methods: {
        emitEdit() {
            this.$emit(`edit`)
        }
    }
})
</script>

<style scoped>
.account-user-info-card {
    padding: 18px;
    color: #f1f2f5;
    background: linear-gradient(120deg, rgba(219, 81, 32, 0.085), rgba(255, 255, 255, 0.025) 54%),
        rgba(23, 25, 31, 0.38);
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    border-radius: 9px;
    box-shadow: none !important;
}
.account-user-info-card__identity {
    display: flex;
    min-width: 0;
    align-items: center;
    gap: 13px;
}
.account-user-info-card__avatar {
    display: grid;
    width: 45px;
    height: 45px;
    flex: 0 0 45px;
    color: #fff;
    background: #db5120;
    border: 1px solid rgba(255, 185, 154, 0.28);
    border-radius: 12px;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0.4px;
    place-items: center;
}
.account-user-info-card__copy {
    min-width: 0;
    flex: 1;
}
.account-user-info-card__eyebrow {
    color: #f2a58b;
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 1.25px;
}
.account-user-info-card__copy h3 {
    margin: 3px 0 1px;
    color: #f4f5f8;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.35;
    overflow-wrap: anywhere;
}
.account-user-info-card__copy p {
    margin: 0;
    color: #aeb5c3;
    font-size: 11px;
}
.account-user-info-card__edit.v-btn {
    color: #ff9a74;
    background: rgba(219, 81, 32, 0.1);
    border: 1px solid rgba(240, 120, 76, 0.25);
}
.account-user-info-card__edit.v-btn:hover {
    background: rgba(219, 81, 32, 0.2);
}
.account-user-info-card__contacts {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    margin-top: 17px;
    padding-top: 14px;
    border-top: 1px solid rgba(255, 255, 255, 0.09);
}
.account-user-info-card__contact {
    display: flex;
    min-width: 0;
    align-items: center;
    gap: 9px;
    color: #e3e5eb;
    font-size: 11px;
    overflow-wrap: anywhere;
}
.account-user-info-card__contact-icon {
    display: grid;
    width: 29px;
    height: 29px;
    flex: 0 0 29px;
    color: #f2a58b;
    background: rgba(255, 255, 255, 0.045);
    border-radius: 8px;
    place-items: center;
}
.account-user-info-card__contact-icon .v-icon {
    color: inherit;
    font-size: 16px;
}
.account-user-info-card__contact > span:last-child {
    min-width: 0;
}
.account-user-info-card__contact small {
    display: block;
    margin-bottom: 2px;
    color: #929bad;
    font-size: 9px;
}
@media (max-width: 480px) {
    .account-user-info-card__contacts {
        grid-template-columns: minmax(0, 1fr);
    }
}
</style>
